<template>
  <div class="min-body">
    <!-- banner -->
    <banner :banner-list="bannerList"></banner>
    <!-- 产品功能 -->
    <ProductFunctions :alternateList="alternateList"></ProductFunctions>

    <!-- 客户案例 -->
    <SectionTitle :title="$t('sectionTitle.customerCase')" subtitle="" style="margin:100px 0 30px 0;" />
    <CustomerCase :caseList="caseList"></CustomerCase>
    <!-- Footer -->
    <Footer></Footer>
  </div>
</template>

<script>
import Footer from '@/components/Footer'
import SectionTitle from "@/components/SectionTitle/index.vue";
import CustomerCase from "@/views/Home/components/CustomerCase/index.vue";
import banner from "@/views/Home/components/Banner/banner.vue";
import ProductFunctions from "./components/ProductFunctions.vue";

// 引入 JSON 配置
import detailsConfig from '@/config/details.js'

export default {
  name: "index",
  components:{
    banner,
    CustomerCase,
    SectionTitle,
    Footer,
    ProductFunctions
  },
  data() {
    return {
      bannerList: [],
      alternateList: [],
      caseList: []
    }
  },
  mounted() {
    window.scrollTo(0, 0);
    this.loadDataByType();
  },
  methods: {
    // 从路由取 type，加载对应 JSON 数据
    loadDataByType() {
      // 从路由获取 type
      const type = this.$route.query.type || 'WenMei';

      // 取出对应数据
      const data = detailsConfig[type] || {};

      // 赋值
      this.bannerList = data.bannerList || [];
      this.alternateList = data.alternateList || [];
      this.caseList = data.caseList || [];
    }
  }
}
</script>

<style scoped>
.min-body {
  width: 100%;
}
</style>